import { ReactElement, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Collapse from '@material-ui/core/Collapse';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import ExpandMore from '@mui/icons-material/ExpandMore';
import ExpandLess from '@mui/icons-material/ExpandLess';
import { ReactComponent as SocialIcon } from '../../../../assets/images/Social.svg';
import { CustomerFacebookSection } from 'components/SocialMedia/Customers/CustomerFacebookSection';
import { CustomerInstagramSection } from 'components/SocialMedia/Customers/CustomerInstagramSection';
import { SocialCustomerDto } from 'common/models/customer';
import { useSocialTestDealer } from 'common/context/SocialTestDealerContext';

export interface SocialAccountSectionProps {
    facebookAccounts: SocialCustomerDto[];
    instagramAccounts: SocialCustomerDto[];
}

export function SocialAccountSection({
    facebookAccounts,
    instagramAccounts
}: SocialAccountSectionProps): ReactElement {
    const [expanded, setExpanded] = useState<boolean>(false);
    const { isFacebookTestDealer, isInstagramTestDealer, isSocialTestDealer } = useSocialTestDealer();

    const handleToggle = () => {
        setExpanded(!expanded);
    };

    return (
        <>
            <Grid container spacing={1} justifyContent="space-between" onClick={handleToggle} style={{ cursor: 'pointer' }}>
                <Grid item>
                    <Grid container alignItems="center">
                        <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                            <SocialIcon style={{ marginRight: '5px', width: '24px', height: '24px' }} />
                        </Grid>
                        <Grid item style={{ display: 'flex', alignItems: 'center' }}>
                            <Typography variant="h5"> Social Accounts </Typography>
                        </Grid>
                    </Grid>
                </Grid>
                <Grid item>
                    <Typography>
                        {expanded ? (
                            <ExpandLess style={{ cursor: 'pointer' }} />
                        ) : (
                            <ExpandMore style={{ cursor: 'pointer' }} />
                        )}
                    </Typography>
                </Grid>
            </Grid>
            <Collapse in={expanded}>
                <Grid container spacing={2} style={{ marginTop: '8px' }}>
                    {isFacebookTestDealer && (
                    <Grid item xs={12}>
                        <Card variant="outlined" style={{ borderRadius: '3px', border: '1px solid #DCDCDC' }}>
                            <CardContent>
                                <CustomerFacebookSection facebookAccounts={facebookAccounts} />
                            </CardContent>
                        </Card>
                    </Grid>
                    )}
                    {isInstagramTestDealer && (
                    <Grid item xs={12}>
                        <Card variant="outlined" style={{ borderRadius: '3px', border: '1px solid #DCDCDC' }}>
                            <CardContent>
                                <CustomerInstagramSection instagramAccounts={instagramAccounts} />
                            </CardContent>
                        </Card>
                    </Grid>
                    )}
                </Grid>
            </Collapse>
        </>
    );
}
